import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-replicate-large.tsx
/**
* icon.24.logo.replicate.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE5Ljk5OSA1LjgxSDYuMDIzdjE0LjE4N0g0LjAwMVY0aDE1Ljk5OHptMCAzLjQyMUg5LjgzN3YxMC43NjZINy44MTVWNy40MkgyMHptMCAzLjQxN2gtNi4zNDV2Ny4zNWgtMi4wMjJWMTAuODRoOC4zNjd6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-12735
*/
const Icon24LogoReplicateLarge = memo(function Icon24LogoReplicateLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M19.999 5.81H6.023v14.187H4.001V4h15.998zm0 3.421H9.837v10.766H7.815V7.42H20zm0 3.417h-6.345v7.35h-2.022V10.84h8.367z"
		})
	});
});
//#endregion
export { Icon24LogoReplicateLarge };

//# sourceMappingURL=icon-24-logo-replicate-large.js.map